import { logger } from '../utils/logger';
import { authAxios } from '../utils/apiConfig';

const roadmapAxios = authAxios;

export async function submitRoadmapFeedback(feedbackData) {
  // Basic input validation (can be expanded)
  if (!feedbackData || !feedbackData.email || !feedbackData.email.includes('@')) {
    throw new Error('Invalid email format in feedback');
  }
  if (!feedbackData.message || feedbackData.message.trim().length === 0) {
    throw new Error('Feedback message cannot be empty');
  }
  if (!feedbackData.name || feedbackData.name.trim().length === 0) {
    throw new Error('Name cannot be empty');
  }

  try {
    // Assuming your backend endpoint for roadmap feedback is /api/roadmap-feedback
    // The backend will handle writing to the 'roadmap_feedback' MongoDB collection.
    const response = await roadmapAxios.post('/roadmap-feedback', {
      feedbackType: feedbackData.feedbackType,
      priority: feedbackData.priority,
      name: feedbackData.name.trim(),
      email: feedbackData.email.trim().toLowerCase(),
      subject: feedbackData.subject ? feedbackData.subject.trim() : '',
      message: feedbackData.message.trim(),
      submittedAt: new Date().toISOString(), // Add a timestamp
    });
    return response.data;
  } catch (error) {
    logger.error('Roadmap feedback submission error:', error);
    // More specific error handling can be done based on error.response
    if (error.response && error.response.data && error.response.data.message) {
        throw new Error(error.response.data.message);
    }
    throw new Error('Unable to submit feedback. Please try again later.');
  }
} 